import { Stack, Typography } from "@mui/material";
import { useTransactionInvoiceSend } from "Api/Mutations/Transactions/useTransactionInvoiceSend";
import { EmailForm } from "Components/Transactions/Anonymous/EmailForm";
import { Resources, useResource } from "Translations/Resources";

const ComponentResources = Resources.Transactions;

type Props = {
  transactionPublicID: string;
  onEmailSent: () => void;
};

export const EmailOrDownloadInvoiceForm = ({
  transactionPublicID,
  onEmailSent,
}: Props) => {
  const { t } = useResource();
  const { mutate: sendEmailInvoice, isPending } = useTransactionInvoiceSend({
    onSuccess: onEmailSent,
  });

  const handleReceiptSubmission = (email: string) => {
    sendEmailInvoice({ transactionPublicID, email });
  };

  // const onReceiptDownload = () => {}; //TODO: implement receipt download

  return (
    <Stack gap={4}>
      <Typography variant="h6" fontWeight={600} textAlign="center" px={4}>
        {t(ComponentResources.ReceiptOnly)}
      </Typography>
      <EmailForm isPending={isPending} onSubmit={handleReceiptSubmission} />
      {/* <BlDivider text="nebo" />
      <Box display="flex" justifyContent="center">
        <BlTextButton onClick={onReceiptDownload}>
          {t(ComponentResources.Anonymous.DownloadReceipt)}
        </BlTextButton>
      </Box> */}
    </Stack>
  );
};
